import React, { useContext } from 'react'
import QuizContext from '../QuizContext'
import { useRestartQuiz } from '../store'

export default function () {
  const quiz = useContext(QuizContext)
  const questions = Object.values(quiz.state.questions.byId).reduce((acc, item) => {
    return acc.concat({
      ...item,
      progress: quiz.state.progress[item.id],
    })
  }, [])
  const progress = quiz.state.progress.quiz
  const handleRestart = () => {
    useRestartQuiz(quiz.dispatch, data => quiz.saveData(data))
  }

  return {
    quiz: quiz.state.quiz,
    progress,
    questions,
    handleRestart,
  }
}
